module.exports = __webpack_public_path__ + "static/media/2D.1c8adbb3.svg";